/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Billing_Mode_Waive_LabelInputs */



/**
* | output |
* | --- |
* | "Waive it and start fresh" |
*
* @param {Partner_Admin_Billing_Mode_Waive_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_mode_waive_label = /** @type {((inputs?: Partner_Admin_Billing_Mode_Waive_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Mode_Waive_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erlassen und neu beginnen")
	return /** @type {LocalizedString} */ ("Waive it and start fresh")
});